module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/2_ffd5480c701d9111d19395d509cd2bcd.png";